import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SALES_PERFORMANCE,
    GET_DOCTOR_REPORT_DETAILS,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS,
    GET_DOCTOR_PERFORMANCE,
    GET_PAY_COMMISSION_REPORT,
    EXPORT_DOCTOR_PERFORMANCE,
    EXPORT_DOCTOR_SALES,
} from "./actionTypes.js";

import {
    getSalesPerformanceSuccess,
    getSalesPerformanceFail,
    getDoctorPerformanceSuccess,
    getDoctorPerformanceFail,
    getDoctorDetailsReportSuccess,
    getDoctorDetailsReportFail,
    getDoctorPaymentReportFail,
    getDoctorPaymentReportSuccess,
    getPayCommissionReportSuccess,
    getPayCommissionReportFail,
    exportDoctorSalesFail,
    exportDoctorSalesSuccess,
    exportDoctorPerformanceSuccess,
    exportDoctorPerformanceFail,
} from "./actions.js";

import {
    salesPerformanceApi,
    doctorPerformanceApi,
    doctorReportDetailsApi,
    doctorPaymentReportApi,
    doctorPayCommissionApi,
    exportDoctorSalesApi,
    exportDoctorPerformanceApi,
} from "./reportApi.js";

function* fetchSalesPerformanceReport({ payload }) {
    try {
        const response = yield call(salesPerformanceApi, payload);
        yield put(getSalesPerformanceSuccess(response));
    } catch (error) {
        yield put(getSalesPerformanceFail(error));
    }
}

function* fetchDoctorPerformanceReport({ payload }) {
    try {
        const response = yield call(doctorPerformanceApi, payload);
        yield put(getDoctorPerformanceSuccess(response));
    } catch (error) {
        yield put(getDoctorPerformanceFail(error));
    }
}

function* fetchDoctorDetailsReport({ payload }) {
    try {
        const response = yield call(doctorReportDetailsApi, payload);
        yield put(getDoctorDetailsReportSuccess(response));
    } catch (error) {
        yield put(getDoctorDetailsReportFail(error));
    }
}

function* fetchDoctorPaymentReport({ payload }) {
    try {
        const response = yield call(doctorPaymentReportApi, payload);
        yield put(getDoctorPaymentReportSuccess(response));
    } catch (error) {
        yield put(getDoctorPaymentReportFail(error));
    }
}

function* fetchDoctorPayCommission({ payload }) {
    try {
        const response = yield call(doctorPayCommissionApi, payload);
        yield put(getPayCommissionReportSuccess(response));
    } catch (error) {
        yield put(getPayCommissionReportFail(error));
    }
}

function* fetchDoctorPerformanceDocument({ payload }) {
    try {
        const response = yield call(exportDoctorPerformanceApi, payload);
        yield put(exportDoctorPerformanceSuccess(response));
    } catch (error) {
        yield put(exportDoctorPerformanceFail(error));
    }
}

function* fetchDoctorSalesDocument({ payload }) {
    try {
        const response = yield call(exportDoctorSalesApi, payload);
        yield put(exportDoctorSalesSuccess(response));
    } catch (error) {
        yield put(exportDoctorSalesFail(error));
    }
}


function* ReportSaga() {
    yield takeEvery(GET_SALES_PERFORMANCE, fetchSalesPerformanceReport);
    yield takeEvery(GET_DOCTOR_PERFORMANCE, fetchDoctorPerformanceReport);
    yield takeEvery(GET_DOCTOR_REPORT_DETAILS, fetchDoctorDetailsReport);
    yield takeEvery(GET_DOCTOR_PAYMENT_REPORT_DETAILS, fetchDoctorPaymentReport);
    yield takeEvery(GET_PAY_COMMISSION_REPORT, fetchDoctorPayCommission);
    yield takeEvery(EXPORT_DOCTOR_PERFORMANCE, fetchDoctorPerformanceDocument);
    yield takeEvery(EXPORT_DOCTOR_SALES, fetchDoctorSalesDocument);
}

export default ReportSaga
